/**
 * @desc 使用axios作为通用http支持
 */
import axios from 'axios';
import { tryVerify } from './verify';

function axiosPromise(promise) {
  return new Promise((resolve, reject) => {
    promise.then((res) => {
      tryVerify(res).then((response) => {
        resolve(response);
      }).catch((response) => {
        resolve(response);
      });
    }).catch((error) => {
      reject(error);
    });
  });
}

function bind(fn, thisArg) {
  return function wrap() {
    const args = new Array(arguments.length);
    for (let i = 0; i < args.length; i += 1) {
      // eslint-disable-next-line prefer-rest-params
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
}

function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    obj = [obj];
  }

  if (Array.isArray(obj)) {
    // Iterate over array values
    for (let i = 0, l = obj.length; i < l; i += 1) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    Object.keys(obj).forEach((key) => {
      fn.call(null, obj[key], key, obj);
    });
  }
}

function extend(a, b, thisArg) {
  forEach(b, (val, key) => {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

const { Axios } = axios;
function createInstance(defaultConfig) {
  const context = new Axios(defaultConfig);

  let instance;

  function request() {
    console.log('request');
    // eslint-disable-next-line prefer-rest-params
    return instance.request(...arguments);
  }

  // const instance = bind(Axios.prototype.request, context);
  instance = bind(request, context);

  // Copy axios.prototype to instance
  extend(instance, Axios.prototype, context);

  // Copy context to instance
  extend(instance, context);

  Object.keys(axios).forEach((key) => {
    if (typeof axios[key] === 'function') {
      instance[key] = function () {
        console.log(key);
        if (['request', 'delete', 'get', 'head', 'options', 'post', 'put', 'patch'].includes(key)) {
          // eslint-disable-next-line prefer-rest-params
          return axiosPromise(axios[key].call(context, ...arguments));
        }
        // eslint-disable-next-line prefer-rest-params
        return axios[key].call(context, ...arguments);
      };
    } else {
      instance[key] = axios[key];
    }
  });

  return instance;
}

const axios2 = createInstance(axios.defaults);
axios2.create = function (instanceConfig) {
  return createInstance(instanceConfig);
};
axios2.Cancel = axios.Cancel;
axios2.CancelToken = axios.CancelToken;
axios2.isCancel = axios.isCancel;

// Expose all/spread
axios2.all = axios.all;
axios2.spread = axios.spread;

export default axios2;
